import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { SiteLayout } from "@/components/site/SiteLayout";
import { SEOHead } from "@/components/SEOHead";

const MentionsLegalesPage = () => {
  return (
    <SiteLayout>
      <SEOHead
        title="Mentions Légales"
        description="Mentions légales du site controle-technique-montreuil-sous-bois.fr. Informations sur l'éditeur, l'hébergeur et les conditions d'utilisation."
        path="/mentions-legales"
        noindex
      />
      {/* Hero */}
      <section className="relative py-20 bg-gradient-to-br from-autosur-navy to-autosur-blue overflow-hidden">
        <div className="container mx-auto px-6 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center max-w-3xl mx-auto"
          >
            <span className="text-autosur-red font-heading font-semibold tracking-widest text-sm mb-4 block">
              INFORMATIONS LÉGALES
            </span>
            <h1 className="font-heading text-4xl md:text-5xl font-bold text-white mb-4">
              Mentions légales
            </h1>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-background">
        <div className="container mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="max-w-4xl mx-auto"
          >
            {/* 1. Éditeur du site */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl font-bold text-autosur-navy mb-4">
                1. Éditeur du site
              </h2>
              <p className="font-body text-muted-foreground leading-relaxed mb-4">
                Le site internet controle-technique-montreuil-sous-bois.fr est édité par la SARL <strong>B-TO CORP</strong>, au capital social de 5 000 euros, dont le siège social est situé : Ilot Quai 8.2, Bâtiment E1, 31 Rue d'Armagnac, 33800 Bordeaux, France, immatriculée au RCS de Bordeaux sous le numéro 993 190 370 00011.
              </p>
              <div className="bg-autosur-grey-light rounded-xl p-6 space-y-2 font-body text-muted-foreground">
                <p><strong className="text-autosur-navy">Directeur de la publication :</strong> B-TO CORP</p>
                <p>
                  <strong className="text-autosur-navy">Email :</strong>{" "}
                  <a href="mailto:contact@b-to.io" className="text-autosur-blue hover:text-autosur-navy underline">
                    contact@b-to.io
                  </a>
                </p>
                <p><strong className="text-autosur-navy">Téléphone :</strong> 05 54 54 65 29</p>
              </div>
            </div>

            {/* 2. Hébergement */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl font-bold text-autosur-navy mb-4">
                2. Hébergement du site
              </h2>
              <p className="font-body text-muted-foreground leading-relaxed">
                Le site est hébergé par <strong>OVH</strong>, SAS au capital de 10 174 560 €.
              </p>
              <div className="bg-autosur-grey-light rounded-xl p-6 space-y-2 font-body text-muted-foreground mt-4">
                <p><strong className="text-autosur-navy">Siège social :</strong> 2 rue Kellermann, 59100 Roubaix, France</p>
                <p><strong className="text-autosur-navy">Téléphone :</strong> +33 (0)9 72 10 10 07</p>
                <p>
                  <strong className="text-autosur-navy">Site web :</strong>{" "}
                  <a href="https://www.ovh.com/" target="_blank" rel="noopener noreferrer" className="text-autosur-blue hover:text-autosur-navy underline">
                    www.ovh.com
                  </a>
                </p>
              </div>
            </div>

            {/* 3. Objet du site */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl font-bold text-autosur-navy mb-4">
                3. Objet du site
              </h2>
              <p className="font-body text-muted-foreground leading-relaxed">
                Présentation des activités et services d'<strong>ABS AUTO BILAN SERVICE</strong>, centre de contrôle technique agréé sous l'enseigne Autosur, situé à Montreuil-sous-Bois.
              </p>
            </div>

            {/* 4. Propriété intellectuelle */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl font-bold text-autosur-navy mb-4">
                4. Propriété intellectuelle
              </h2>
              <p className="font-body text-muted-foreground leading-relaxed">
                Tous les éléments du site (textes, images, logos, vidéos, etc.) sont la propriété exclusive d'ABS AUTO BILAN SERVICE et/ou du réseau Autosur. Toute reproduction ou exploitation non autorisée est interdite.
              </p>
            </div>

            {/* 5. Liens hypertextes */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl font-bold text-autosur-navy mb-4">
                5. Liens hypertextes
              </h2>
              <p className="font-body text-muted-foreground leading-relaxed">
                Toute mise en place de lien vers le site nécessite une autorisation écrite préalable. ABS AUTO BILAN SERVICE décline toute responsabilité pour le contenu des sites externes.
              </p>
            </div>

            {/* 6. Données personnelles et cookies */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl font-bold text-autosur-navy mb-4">
                6. Données personnelles et cookies
              </h2>
              <p className="font-body text-muted-foreground leading-relaxed mb-4">
                Des cookies peuvent être installés automatiquement. L'utilisateur peut les accepter, refuser ou paramétrer via son navigateur.
              </p>
              <p className="font-body text-muted-foreground leading-relaxed mb-4">
                Conformément à la loi Informatique et Libertés et au RGPD, l'utilisateur dispose d'un droit d'accès, de rectification et de suppression de ses données personnelles.
              </p>
              <p className="font-body text-muted-foreground leading-relaxed mb-4">
                <strong className="text-autosur-navy">Contact :</strong>{" "}
                <a href="mailto:autosur.montreuil@gmail.com" className="text-autosur-blue hover:text-autosur-navy underline">
                  autosur.montreuil@gmail.com
                </a>
              </p>
              <p className="font-body text-muted-foreground leading-relaxed">
                Pour plus d'informations, consultez notre{" "}
                <Link to="/politique-confidentialite" className="text-autosur-blue hover:text-autosur-navy underline">
                  politique de confidentialité
                </Link>{" "}
                et notre{" "}
                <Link to="/politique-cookies" className="text-autosur-blue hover:text-autosur-navy underline">
                  politique des cookies
                </Link>.
              </p>
            </div>

            {/* 7. Responsabilité */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl font-bold text-autosur-navy mb-4">
                7. Responsabilité
              </h2>
              <p className="font-body text-muted-foreground leading-relaxed">
                L'utilisateur doit disposer des compétences et moyens nécessaires pour accéder et utiliser le site. ABS AUTO BILAN SERVICE ne peut être tenue responsable d'erreurs, omissions ou indisponibilités temporaires du site.
              </p>
            </div>

            {/* 8. Médiation */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl font-bold text-autosur-navy mb-4">
                8. Médiation à la consommation
              </h2>
              <p className="font-body text-muted-foreground leading-relaxed">
                Recours gratuit à un médiateur disponible sur :{" "}
                <a 
                  href="https://www.economie.gouv.fr/mediation-conso" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-autosur-blue hover:text-autosur-navy underline"
                >
                  www.economie.gouv.fr/mediation-conso
                </a>
              </p>
            </div>

            {/* 9. Crédits */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl font-bold text-autosur-navy mb-4">
                9. Crédits et conception du site
              </h2>
              <p className="font-body text-muted-foreground leading-relaxed">
                Design et développement : <strong>B-TO CORP</strong>, agence digitale spécialisée en création de sites web, branding & design et optimisation SEO.
              </p>
              <p className="font-body text-muted-foreground leading-relaxed mt-2">
                <a 
                  href="https://www.b-to.io/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-autosur-blue hover:text-autosur-navy underline"
                >
                  www.b-to.io
                </a>
              </p>
            </div>

            {/* 10. Droit applicable */}
            <div className="mb-10">
              <h2 className="font-heading text-2xl font-bold text-autosur-navy mb-4">
                10. Droit applicable
              </h2>
              <p className="font-body text-muted-foreground leading-relaxed">
                Droit français. Tribunaux compétents : tribunaux français.
              </p>
            </div>

            {/* Back link */}
            <div className="pt-8 border-t border-gray-200">
              <Link 
                to="/" 
                className="inline-flex items-center gap-2 text-autosur-blue hover:text-autosur-navy font-heading font-semibold transition-colors"
              >
                ← Retour à l'accueil
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </SiteLayout>
  );
};

export default MentionsLegalesPage;
